import React from 'react';
import { IconProps } from '.';

const SvgColoredCalendar = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#EFF0F0'
        d='M1.6 5a2.6 2.6 0 0 1 2.6-2.6h15.6A2.6 2.6 0 0 1 22.4 5v14.8a2.6 2.6 0 0 1-2.6 2.6H4.2a2.6 2.6 0 0 1-2.6-2.6V5Z'
      />
      <path
        fill='#262829'
        d='M10.097 10.51v7.918h-1.87v-6.169h-.044L6.4 13.353v-1.619l1.958-1.225h1.739ZM11.836 18.428v-1.345l2.887-2.538c.673-.612 1.056-1.017 1.061-1.618-.005-.662-.492-1.067-1.159-1.072-.678.005-1.132.432-1.127 1.148h-1.771c-.006-1.597 1.164-2.603 2.909-2.603 1.783 0 2.948.968 2.953 2.384-.005.908-.454 1.668-2.166 3.161l-.995.919v.055h3.26v1.509h-5.852Z'
      />
      <path fill='#91D6A7' d='M4.2 2.4A2.6 2.6 0 0 0 1.6 5v2.2h20.8V5a2.6 2.6 0 0 0-2.6-2.6H4.2Z' />
      <path
        fill='#209D48'
        fillRule='evenodd'
        d='M7.2.8a.8.8 0 0 1 .8.8V4a.8.8 0 1 1-1.6 0V1.6a.8.8 0 0 1 .8-.8ZM16.8.8a.8.8 0 0 1 .8.8V4A.8.8 0 0 1 16 4V1.6a.8.8 0 0 1 .8-.8Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgColoredCalendar;
